import Nora from '@primeuix/themes/nora';
import { definePreset } from '@primeuix/themes';

export const SELECT_COLOR = '{primary.900}';
export const SELECT_BG_COLOR = '{primary.100}';
export const SELECT_BG_COLOR_DARKER = '{primary.200}';

export const TratonPreset = definePreset(Nora, {
    semantic: {
        formField: {
            paddingX: '0.5rem',
            paddingY: '0.25rem',
        },
        primary: {
            100: '#b3dce1',
            200: '#8ccad2',
            300: '#66b8c4',
            400: '#2d9ead',
            500: '#008294',
            600: '#006371',
            700: '#004852',
            800: '#003137',
            900: '#001d21',
        },
        warmGray: {
            50: '#fcfbf7',
            100: '#f5f1e6',
            200: '#ebe7dd',
            300: '#d6d4c9',
            400: '#c2bfb6',
            500: '#a6a49c',
        },
        yellow: {
            400: '#ffd04a',
            500: '#ffc00d',
            700: '#d9a100',
        },
    },
    components: {
        toolbar: {
            root: {
                borderRadius: 'var(--st-border-radius)',
                borderColor: '{surface.300}',
            },
        },
        progressbar: {
            root: {
                height: '6px',
            },
        },
        accordion: {
            header: {
                padding: '0.75rem',
            },
            content: {
                padding: '0.75rem',
            },
        },
        listbox: {
            root: {
                borderColor: '{surface.300}',
            },
            option: {
                selectedBackground: SELECT_BG_COLOR,
                selectedFocusBackground: SELECT_BG_COLOR_DARKER,
                selectedColor: SELECT_COLOR,
                selectedFocusColor: SELECT_COLOR,
            },
        },
        treetable: {
            headerCell: {
                padding: '0.25rem',
            },
            bodyCell: {
                padding: '0.25rem',
            },
            row: {
                selectedBackground: SELECT_BG_COLOR,
                selectedColor: SELECT_COLOR,
            },
        },
        datatable: {
            header: {
                borderWidth: '0 0 1px 0',
            },
            headerCell: {
                padding: '0.125rem 0.5rem',
            },
            row: {
                background: '{surface.0}',
                selectedBackground: SELECT_BG_COLOR,
                selectedColor: SELECT_COLOR,
            },
            bodyCell: {
                padding: '0.125rem 0.5rem',
            },
            footer: {
                borderWidth: '0',
                padding: '0',
            },
            footerCell: {
                padding: '0',
            },
        },
        card: {
            root: {
                borderRadius: 'var(--st-border-radius)',
                shadow: '0',
            },
        },
        select: {
            root: {
                borderColor: '{surface.400}',
                focusBorderColor: '{primary.600}',
                focusRing: {
                    width: '0',
                },
            },
            option: {
                padding: '0.25rem 0.5rem',
                color: SELECT_COLOR,
                focusColor: SELECT_COLOR,
                selectedColor: SELECT_COLOR,
                selectedFocusColor: SELECT_COLOR,
                selectedBackground: SELECT_BG_COLOR,
                selectedFocusBackground: SELECT_BG_COLOR_DARKER,
            },
        },
        inputtext: {
            root: {
                borderColor: '{surface.400}',
            },
        },
        textarea: {
            root: {
                borderColor: '{surface.400}',
            },
        },
        contextmenu: {
            root: {
                borderColor: '{surface.300}',
                borderRadius: 'var(--st-border-radius)',
            },
            item: {
                padding: '0.5rem',
                focusBackground: SELECT_BG_COLOR,
                focusColor: SELECT_COLOR,
                icon: {
                    focusColor: SELECT_COLOR,
                },
            },
        },
        tieredmenu: {
            root: {
                borderColor: '{surface.300}',
                borderRadius: 'var(--st-border-radius)',
            },
            item: {
                padding: '0.5rem',
                focusBackground: SELECT_BG_COLOR,
                focusColor: SELECT_COLOR,
                icon: {
                    focusColor: SELECT_COLOR,
                },
            },
            submenuIcon: {
                focusColor: SELECT_COLOR,
            },
        },
        button: {
            root: {
                label: {
                    fontWeight: '400',
                },
            },
        },
    },
});
